{
  "price_list_item": {
    "title": "Set up a price list",
    "complete": "You've created a wholesale price list.",
    "learn_more": "What's a price list?",
    "description": "Set up a wholesale price list by applying a discount to your store prices. You can then assign it to a customer group.",
    "submit": "Create price list",
    "setup_myself": "Set up myself",
    "manage": "Manage price lists",
    "error_invalid_amount": "Enter a discount between 0 and 100.",
    "error_generic": "Something went wrong saving your price list. Please try again."
  },
  "price_list_assignment_item": {
    "title": "Assign a price list to a customer group",
    "description": "Choose a customer group and the price list it should use, then assign it. That's how SparkLayer knows which wholesale prices to show that group.",
    "group_label": "Customer group",
    "price_list_label": "Price list",
    "group_placeholder": "Select a customer group",
    "price_list_placeholder": "Select a price list",
    "no_price_lists": "Create a price list",
    "setup_price_list_prompt": "You'll need a price list before you can assign one to a customer group.",
    "assign": "Assign",
    "complete": "You've assigned a price list to a customer group. That group will see those wholesale prices.",
    "manage": "Manage customer groups",
    "error_generic": "Something went wrong assigning the price list. Please try again."
  },
  "price_list_assignment_preview": {
    "assigned": "Assigned",
    "discount": "−20%"
  },
  "customer_preview": {
    "account_type": "B2B customer"
  },
  "customer_item": {
    "title": "Test as a B2B customer",
    "complete": "You're testing as your B2B customer in your default customer group with its associated price lists.",
    "complete_with_email": "You're testing as {email} in your default customer group with its associated price lists.",
    "learn_more": "What's a customer group?",
    "edit": "Use a different customer",
    "keep_existing": "Use {email}",
    "description": "Enter an email you can sign in to. If a B2B customer with that email already exists we'll use it; otherwise we'll create one in your default customer group and email them an invite to set their password.",
    "email_placeholder": "customer@example.com",
    "submit": "Test as this customer",
    "error_invalid_email": "Enter a valid email address.",
    "error_generic": "Something went wrong creating the customer. Please try again."
  },
  "widget_item": {
    "title": "Enable the SparkLayer widget",
    "description": "Enable the SparkLayer widget so we can take control of areas of your store when a B2B customer is signed in. Your normal storefront stays exactly as it is for everyone else.",
    "enable": "Enable widget",
    "enabling": "Enabling…",
    "enabled_complete": "The SparkLayer widget is enabled. You're ready to test your store with a real B2B customer.",
    "error": "Couldn't check if the widget is enabled.",
    "retry": "Retry",
    "checking": "Checking whether the widget is enabled…",
    "product": "Product",
    "variant": "Product variant"
  },
  "order_item": {
    "title": "Place a test order",
    "complete": "You've placed a test order. You've seen the full B2B checkout your customers will use, end to end.",
    "description": "Experience your store as a B2B buyer and place a test order.",
    "learn_more": "Why place a test order?",
    "prefill_adding": "Adding a product to your cart…",
    "prefill_added": "We've added a product to your cart, ready for checkout.",
    "prefill_manual": "We couldn't add a product to your cart. Add any product once you've signed in.",
    "cta": "Place a test order",
    "skip": "I'll do this later",
    "instruction_sign_in": "Open your store and sign in as {email}",
    "instruction_cart": "Go to your cart",
    "instruction_cart_manual": "Add a product to your cart",
    "instruction_checkout": "Go through checkout and place the order",
    "waiting": "We're waiting for your order! Complete checkout on your storefront and this step will tick automatically."
  },
  "cart_preview": {
    "product": "Product",
    "my_cart": "My Cart",
    "my_account": "My Account"
  },
  "setup_banner": {
    "title": "Finish setting up your store",
    "cta": "Continue setup",
    "next": "Next: {title}",
    "launch_title": "You're ready for real B2B orders",
    "launch_cta": "Start taking B2B orders",
    "launch_body": "You've completed the essential setup steps and you're ready to take real B2B orders. You can also add more price lists and customer groups before you launch. Not ready yet?",
    "talk_to_onboarding": "Talk to onboarding"
  }
}
